import {view} from '@sail/engine';
import {ComponentProps, forwardRef} from 'react';
import {useItemsGroupedV2} from '../../helpers/useItemsGroupedV2';
import {
  useItemsDotCom,
  DotComChatBubbleAnimationContext,
} from './useItemsDotCom';
import {LogItems, renderItemsGroupedV1} from './LogItems';

export const DotComLogItems = forwardRef<
  HTMLDivElement,
  ComponentProps<typeof LogItems>
>(({conversation, items, animated, disableInteraction}, ref) => {
  const dotComItems = useItemsDotCom(conversation, items);

  let rows = useItemsGroupedV2(conversation, dotComItems.items, {
    useNewDesign: false,
    useDotComDesign: true,
    animated,
    disableInteraction,
  });

  if (rows == null) {
    rows = renderItemsGroupedV1(conversation, dotComItems.items, {
      useNewDesign: false,
      useDotComDesign: true,
      animated,
      disableInteraction,
    });
  }

  return (
    <view.div
      ref={ref}
      data-testid="conversation-log-items"
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'medium',
      }}
    >
      <DotComChatBubbleAnimationContext.Provider
        value={dotComItems.contextValue}
      >
        {rows}
      </DotComChatBubbleAnimationContext.Provider>
    </view.div>
  );
});
